import frMessages from '../locales/fr_FR.json';
import merchandisingMessages from '../locales/merchandising';

const FrLang = {
  messages: {
    ...merchandisingMessages,
    ...frMessages,
  },
  locale: 'fr-FR',
};
export default FrLang;
